"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addMeToYourFriendsDiv", {
  enumerable: true,
  get: function () {
    return _addMeToYourFriends.addMeToYourFriendsDiv;
  }
});
Object.defineProperty(exports, "checkIfThingExists", {
  enumerable: true,
  get: function () {
    return _addMeToYourFriends.checkIfThingExists;
  }
});
Object.defineProperty(exports, "createAddMeToYourFriendsButton", {
  enumerable: true,
  get: function () {
    return _addMeToYourFriends.createAddMeToYourFriendsButton;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "saveNewThing", {
  enumerable: true,
  get: function () {
    return _addMeToYourFriends.saveNewThing;
  }
});
var _litHtml = require("lit-html");
var _ProfileView = require("./ProfileView");
var _solidUi = require("solid-ui");
var _QRCodeCard = require("./sections/qrcode/QRCodeCard");
var _addMeToYourFriends = require("./specialButtons/addMeToYourFriends");
async function loadExtendedProfile(store, subject) {
  const otherProfiles = store.each(subject, _solidUi.ns.rdfs('seeAlso'), null, subject.doc());
  if (otherProfiles.length > 0) {
    await store.fetcher.load(otherProfiles);
  }
}
const HEADING_SECTION_SELECTOR = '[data-profile-section="heading"]';
const SOCIAL_SECTION_SELECTOR = '[data-profile-section="social"]';
function syncSocialSectionHeight(root) {
  let animationFrameId = 0;
  const updateHeight = () => {
    animationFrameId = 0;
    const grid = root.querySelector('.profile-grid');
    const headingSection = root.querySelector(HEADING_SECTION_SELECTOR);
    const socialSection = root.querySelector(SOCIAL_SECTION_SELECTOR);
    if (!grid || !headingSection || !socialSection) {
      return;
    }
    const isDesktopGrid = root.dataset.layout !== 'mobile' && getComputedStyle(grid).display === 'grid';
    if (!isDesktopGrid) {
      socialSection.style.removeProperty('min-height');
      return;
    }
    const nextMinHeight = `${Math.ceil(headingSection.getBoundingClientRect().height)}px`;
    if (socialSection.style.minHeight !== nextMinHeight) {
      socialSection.style.minHeight = nextMinHeight;
    }
  };
  const scheduleUpdate = () => {
    if (animationFrameId !== 0) {
      return;
    }
    animationFrameId = window.requestAnimationFrame(updateHeight);
  };
  updateHeight();
  if (typeof ResizeObserver === 'undefined') {
    window.addEventListener('resize', scheduleUpdate);
    return () => {
      if (animationFrameId !== 0) {
        window.cancelAnimationFrame(animationFrameId);
      }
      window.removeEventListener('resize', scheduleUpdate);
    };
  }
  const resizeObserver = new ResizeObserver(scheduleUpdate);
  resizeObserver.observe(root);
  const headingSection = root.querySelector(HEADING_SECTION_SELECTOR);
  const socialSection = root.querySelector(SOCIAL_SECTION_SELECTOR);
  if (headingSection) {
    resizeObserver.observe(headingSection);
  }
  if (socialSection) {
    resizeObserver.observe(socialSection);
  }
  return () => {
    if (animationFrameId !== 0) {
      window.cancelAnimationFrame(animationFrameId);
    }
    resizeObserver.disconnect();
  };
}
function applyEnvironmentAttributes(element, context) {
  const layout = context.environment?.layout ?? 'desktop';
  const theme = context.environment?.theme ?? 'light';
  const inputMode = context.environment?.inputMode ?? 'pointer';
  element.classList.add('profile-pane-host');
  element.dataset.layout = layout;
  element.dataset.theme = theme;
  element.dataset.inputMode = inputMode;
}
const Pane = {
  global: false,
  icon: _solidUi.icons.iconBase + 'noun_15059.svg',
  name: 'profile',
  label: function (subject, context) {
    const t = context.session.store.findTypeURIs(subject);
    if (t[_solidUi.ns.vcard('Individual').uri] || t[_solidUi.ns.foaf('Person').uri] || t[_solidUi.ns.schema('Person').uri]) {
      return 'Profile';
    }
    return null;
  },
  render: (subject, context) => {
    const target = context.dom.createElement('div');
    const store = context.session.store;
    let cleanupSocialSectionHeightSync = null;
    applyEnvironmentAttributes(target, context);
    const renderWithData = async () => {
      applyEnvironmentAttributes(target, context);
      (0, _litHtml.render)(await (0, _ProfileView.ProfileView)(subject, context, renderWithData), target);
      cleanupSocialSectionHeightSync?.();
      cleanupSocialSectionHeightSync = syncSocialSectionHeight(target);
      await (0, _QRCodeCard.hydrateQRCodes)(target);
    };
    loadExtendedProfile(store, subject).then(async () => {
      await renderWithData();
    });
    return target;
  }
};
var _default = exports.default = Pane;